import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { PAGE_KEY } from "./constants";
var localePt = /*#__PURE__*/_defineProperty({}, PAGE_KEY, {
  LABEL_FOOTER_TEXT_SHORTER: 'Privacidade de dados e termos de uso.',
  LABEL_HANA_WIDGET_BANNER_CATEGORIES_TITLE: 'Também pode consultar estes tópicos frequentes:',
  LABEL_HANA_WIDGET_VIEW_HISTORY_BUTTON: 'Ver histórico',
  MAIN_CHAT_LABEL_PLACEHOLDER_TEXTAREA: 'Escreva a consulta que deseja realizar',
  LABEL_CATEGORIES: 'Categorias',
  LABEL_FILTER_TITLE: 'Escolha uma opção para obter sugestões de consultas relacionadas',
  LABEL_HANA_ERROR_FETCH_TITLE: 'Erro ao carregar os dados',
  LABEL_HANA_ERROR_FETCH_DESCRIPTION: 'Não foi possível carregar os dados',
  LABEL_HANA_ERROR_FETCH_BUTTON: 'Tentar novamente'
});
export default localePt;